import axios from 'axios'

const createParamsString = (data) => {
  let params = '?'
  for (const key in data) {
    params += `${key}=${encodeURIComponent(data[key])}&`
  }
  return params.slice(0, -1)
}
// Benchmarks
const getBenchmarks = async ({ getters, commit }, data) => {
  const { data: response } = await axios.get(`${getters.apiUrl}/benchmarks/contentplan/${data.contentplanId}`, getters.apiHeader)
  await commit('updateBenchmarks', response)
}

// Internal Links
const loadInternalLinksByArticle = async ({ getters, commit }, data) => {
  const { data: response } = await axios.get(`${getters.apiUrl}/internal-links/article/${data.articleId}?key=${data.sharingKey || ''}`, getters.apiHeader)
  await commit('updateInternalLinks', response)
}

// Free Clusterer
const startClusterer = async ({ getters }, data) => {
  const { data: response } = await axios.post(`${getters.apiUrl}/clusterer`, data, getters.apiHeader)
  return response
}

const getClustererStatus = async ({ getters }, data) => {
  const { data: response } = await axios.get(`${getters.apiUrl}/clusterer?contentplanId=${data.contentplanId}`, getters.apiHeader)
  return response
}

const clustererSendEmail = async ({ getters }, data) => {
  const response = await axios.post(`${getters.apiUrl}/clusterer/email`, data, getters.apiHeader)
  return response
}

// GSC integration
const loadDomains = async ({ getters, commit }) => {
  const { data: domains } = await axios.get(`${getters.apiUrl}/domain`, getters.apiHeader)
  await commit('updateDomains', domains)
}

const getGSCDataAndReturn = async ({ getters }, data) => {
  const { data: response } = await axios.post(`${getters.apiUrl}/contentplan/${data.contentplanId}/gsc`, data, getters.apiHeader)
  return response
}

const getGSCDataByDate = async ({ getters, commit }, data) => {
  const { data: response } = await axios.post(`${getters.apiUrl}/contentplan/${data.contentplanId}/gsc`, data, getters.apiHeader)
  commit('updateGSCDataByDate', response)
}

const getGSCDataByQuery = async ({ getters, commit }, data) => {
  const { data: response } = await axios.post(`${getters.apiUrl}/contentplan/${data.contentplanId}/gsc`, data, getters.apiHeader)
  commit('updateGSCDataByQuery', response)
}

const getGSCDataByPage = async ({ getters, commit }, data) => {
  const { data: response } = await axios.post(`${getters.apiUrl}/contentplan/${data.contentplanId}/gsc`, data, getters.apiHeader)
  commit('updateGSCDataByPage', response)
}

// Clustering visualisation
const postHierarchicalClustering = async ({ getters }, data) => {
  const { data: response } = await axios.post(`${getters.apiUrl}/hierarchical-clustering`, data, getters.apiHeader)
  return response
}

// Workspaces
const loadWorkspaces = async ({ getters, commit }) => {
  const { data: workspaces } = await axios.get(`${getters.apiUrl}/workspace`, getters.apiHeader)
  await commit('updateWorkspaces', workspaces)
}

const updateWorkspace = async ({ getters }, data) => {
  await axios.put(`${getters.apiUrl}/workspace/${data.workspaceId}`, data, getters.apiHeader)
}

// Contentplans
const loadContentplans = async ({ getters, commit }, data) => {
  const { data: contentplans } = await axios.get(`${getters.apiUrl}/workspace/${data.workspaceId}/contentplan`, getters.apiHeader)
  await commit('updateContentplans', contentplans)
}

const createContentplan = async ({ getters, dispatch }, data) => {
  const { data: contentplan } = await axios.post(`${getters.apiUrl}/workspace/${data.workspaceId}/contentplan`, data, getters.apiHeader)
  await dispatch('loadContentplans', { workspaceId: data.workspaceId })
  return contentplan
}

const loadContentplan = async ({ getters, commit }, data) => {
  const { data: contentplan } = await axios.get(`${getters.apiUrl}/contentplan/${data.contentplanId}`, getters.apiHeader)
  await commit('updateActiveContentplan', contentplan)
}

const updateContentplan = async ({ getters }, data) => {
  await axios.put(`${getters.apiUrl}/workspace/${data.workspaceId}/contentplan`, data, getters.apiHeader)
}

// Keywords
const loadContentplanKeywords = async ({ getters, commit }, data) => {
  const { data: keywords } = await axios.get(`${getters.apiUrl}/contentplan/${data.contentplanId}/keyword${createParamsString(data)}`, getters.apiHeader)
  await commit('updateContentplanKeywords', keywords)
}

const loadPageKeywords = async ({ getters, commit }, data) => {
  const { data: keywords } = await axios.get(`${getters.apiUrl}/contentplan/${data.contentplanId}/keyword/page?pageId=${data.pageId || ''}&key=${data.sharingKey || ''}`, getters.apiHeader)
  await commit('updatePageKeywords', keywords)
}

const loadArticleKeywords = async ({ getters, commit }, data) => {
  const { data: keywords } = await axios.get(`${getters.apiUrl}/article/${data.articleId}/keyword?key=${data.sharingKey || ''}`, getters.apiHeader)
  if (data.straightReturn) return keywords
  await commit('updateArticleKeywords', keywords)
}

const loadTopicKeywords = async ({ getters, commit }, data) => {
  const { data: keywords } = await axios.get(`${getters.apiUrl}/topic/${data.topicId}/keyword?contentplanId=${data.contentplanId || ''}`, getters.apiHeader)
  commit('loadTopicKeywords', keywords)
}

const getKeyword = async ({ getters }, data) => {
  const { data: keyword } = await axios.get(`${getters.apiUrl}/keyword?keyword=${data.keyword}&contentplanId=${data.contentplanId}`, getters.apiHeader)
  return keyword
}

const getMostPopularKeywords = async ({ getters }, data) => {
  const { data: keywords } = await axios.get(`${getters.apiUrl}/keyword/popular${createParamsString(data)}`, getters.apiHeader)
  return keywords
}

const getRelatedKeywords = async ({ getters }, data) => {
  const { data: keywords } = await axios.post(`${getters.apiUrl}/contentplan/${data.contentplanId}/keyword/related`, data.keywords, getters.apiHeader)
  return keywords
}

const getRelatedKeywordsNlp = async ({ getters }, data) => {
  const { data: keywords } = await axios.post(`${getters.apiUrl}/keyword/related/nlp`, data, getters.apiHeader)
  return keywords
}

const getRelatedBySerpOverlap = async ({ getters }, data) => {
  const { data: keywords } = await axios.get(`${getters.apiUrl}/contentplan/${data.contentplanId}/keyword/related${createParamsString(data)}`, getters.apiHeader)
  return keywords
}

const uploadKeywords = async ({ getters }, data) => {
  await axios.post(`${getters.apiUrl}/contentplan/${data.contentplanId}/keyword`, data, getters.apiHeader)
}

const moveKeywords = async ({ getters }, data) => {
  await axios.put(`${getters.apiUrl}/contentplan/${data.contentplanId}/keyword`, { keywordIds: data.keywordIds, articleId: data.articleId }, getters.apiHeader)
}

const excludeKeywords = async ({ getters }, data) => {
  await axios.put(`${getters.apiUrl}/contentplan/${data.contentplanId}/keyword`, { keywordIds: data.keywordIds, excluded: data.excluded }, getters.apiHeader)
}

const queueKeywords = async ({ getters }, data) => {
  await axios.put(`${getters.apiUrl}/contentplan/${data.contentplanId}/keyword`, { keywordIds: data.keywordIds, queue: data.queue, queueAll: data.queueAll || false }, getters.apiHeader)
}

const queueAllKeywords = async ({ getters }, data) => {
  await axios.put(`${getters.apiUrl}/contentplan/${data.contentplanId}/keyword`, { queueAll: true }, getters.apiHeader)
}

const updateKeywords = async ({ getters }, data) => {
  const { data: response } = await axios.put(`${getters.apiUrl}/contentplan/${data.contentplanId}/keyword`, data, getters.apiHeader)
  return response
}

const getKeywordsByKeyword = async ({ getters }, data) => {
  const { data: keywords } = await axios.get(`${getters.apiUrl}/keyword/${data.keywordId}/keyword?articleId=${data.articleId || ''}`, getters.apiHeader)
  return keywords
}

const processKeywords = async ({ getters }, data) => {
  const { data: keywords } = await axios.post(`${getters.apiUrl}/keyword/process`, data, getters.apiHeader)
  return keywords
}

// Pages
const getPage = async ({ getters }, data) => {
  const { data: page } = await axios.get(`${getters.apiUrl}/page?page=${data.page}&contentplanId=${data.contentplanId}`, getters.apiHeader)
  return page
}

const getPageFromS3 = async ({ getters }, data) => {
  const { data: page } = await axios.get(`${getters.apiUrl}/page/s3?pageId=${data.pageId}`, getters.apiHeader)
  return page
}

const updatePages = async ({ getters }, data) => {
  await axios.put(`${getters.apiUrl}/contentplan/${data.contentplanId}/page`, { pageIds: data.pageIds, excluded: data.excluded, action: data.action, articleIds: data.articleIds, customUrl: data.customUrl, lock: data.lock, mergeWith: data.mergeWith }, getters.apiHeader)
}

const analyzeLandingPage = async ({ getters }, data) => {
  await axios.get(`${getters.apiUrl}/page/${data.pageId}/analyze`, getters.apiHeader)
}

const loadPagesByContentplan = async ({ getters, commit }, data) => {
  const { data: pages } = await axios.get(`${getters.apiUrl}/contentplan/${data.contentplanId}/page${createParamsString(data)}`, getters.apiHeader)
  commit('updatePages', pages)
}

const loadPagesByArticle = async ({ getters, commit }, data) => {
  const { data: pages } = await axios.get(`${getters.apiUrl}/article/${data.articleId}/page?key=${data.sharingKey || ''}`, getters.apiHeader)
  commit('updatePages', pages)
}

const loadPagesByKeywords = async ({ getters, commit }, data) => {
  const { data: pages } = await axios.get(`${getters.apiUrl}/page/keywords${createParamsString(data)}`, getters.apiHeader)
  commit('updatePages', pages)
}

// Topics
const addTopic = async ({ getters }, data) => {
  const { data: id } = await axios.post(`${getters.apiUrl}/contentplan/${data.contentplanId}/topic`, data, getters.apiHeader)
  return id
}

const loadTopics = async ({ getters, commit }, data) => {
  const { data: crawl } = await axios.get(`${getters.apiUrl}/contentplan/${data.contentplanId}/topic`, getters.apiHeader)
  await commit('loadTopics', crawl)
}

const updateTopics = async ({ getters }, data) => {
  await axios.put(`${getters.apiUrl}/contentplan/${data.contentplanId}/topic`, data, getters.apiHeader)
}

// Articles
const addArticle = async ({ getters }, data) => {
  const { data: id } = await axios.post(`${getters.apiUrl}/contentplan/${data.contentplanId}/article`, data, getters.apiHeader)
  return id
}

const loadArticles = async ({ getters, commit }, data) => {
  const { data: articles } = await axios.get(`${getters.apiUrl}/contentplan/${data.contentplanId}/article${createParamsString(data)}`, getters.apiHeader)
  if (data.straightReturn) return articles
  await commit('loadArticles', articles)
}

const loadArticlesAdvanced = async ({ getters, commit }, data) => {
  const { data: articles } = await axios.get(`${getters.apiUrl}/contentplan/${data.contentplanId}/article/advanced${createParamsString(data)}`, getters.apiHeader)
  await commit('loadArticlesAdvanced', articles)
}

const loadArticle = async ({ getters, commit }, data) => {
  const { data: article } = await axios.get(`${getters.apiUrl}/article/${data.articleId}?key=${data.sharingKey || ''}`, getters.apiHeader)
  await commit('loadArticle', article)
}

const loadArticleRankings = async ({ getters, commit }, data) => {
  const { data: rankings } = await axios.get(`${getters.apiUrl}/article/${data.articleIds}/keyword/rank?key=${data.sharingKey || ''}&url=${data.url || ''}`, getters.apiHeader)
  await commit('addArticleRankings', rankings)
}

const loadArticleUrls = async ({ getters, commit }, data) => {
  const { data: urls } = await axios.get(`${getters.apiUrl}/article/${data.articleId}/url?key=${data.sharingKey || ''}&empty=${data.empty || ''}`, getters.apiHeader)
  await commit('updateArticleUrls', urls)
}

const loadArticleExternalUrls = async ({ getters, commit }, data) => {
  const { data: urls } = await axios.get(`${getters.apiUrl}/article/${data.articleId}/url/external?key=${data.sharingKey || ''}`, getters.apiHeader)
  await commit('updateExternalUrls', urls)
}

const updateArticles = async ({ getters }, data) => {
  await axios.put(`${getters.apiUrl}/contentplan/${data.contentplanId}/article`, data, getters.apiHeader)
}

const loadArticlesByArticle = async ({ getters }, data) => {
  const { data: response } = await axios.get(`${getters.apiUrl}/contentplan/${data.contentplanId}/article/${data.articleId}`, getters.apiHeader)
  return response
}

const loadPageArticles = async ({ getters, commit }, data) => {
  const { data: response } = await axios.get(`${getters.apiUrl}/page/${data.pageId}/article`, getters.apiHeader)
  commit('loadPageArticles', response)
}

// Misc
const recalculateAlerts = async ({ getters }, data) => {
  await axios.post(`${getters.apiUrl}/contentplan/${data.contentplanId}/alert`, getters.apiHeader)
}

const postGpt3 = async ({ getters }, data) => {
  await axios.post(`${getters.apiUrl}/article/${data.articleId}/ai?type=${data.type || ''}`, data, getters.apiHeader)
}

const postCopilot = async ({ getters }, data) => {
  const { data: response } = await axios.post(`${getters.apiUrl}/copilot`, data, getters.apiHeader)
  return response
}

const generateBrief = async ({ getters }, data) => {
  await axios.get(`${getters.apiUrl}/article/${data.articleId}/brief`, data, getters.apiHeader)
}

const generateDraft = async ({ getters }, data) => {
  await axios.get(`${getters.apiUrl}/article/${data.articleId}/draft`, getters.apiHeader)
}

// Sections
const loadSections = async ({ getters, commit }, data) => {
  const { data: sections } = await axios.get(`${getters.apiUrl}/article/${data.articleId}/section?key=${data.sharingKey || ''}`, getters.apiHeader)
  await commit('loadSections', sections)
}

const updateSections = async ({ getters }, data) => {
  await axios.put(`${getters.apiUrl}/section/${data.sectionId}`, data, getters.apiHeader)
}

const addSection = async ({ getters }, data) => {
  await axios.post(`${getters.apiUrl}/section/${data.sectionId}`, data, getters.apiHeader)
}

// Misc
const loadScoreAndCommit = async ({ getters, commit }, data) => {
  const { data: score } = await axios.get(`${getters.apiUrl}/contentplan/${data.contentplanId}/article/score?articleId=${data.articleId || ''}&keywordId=${data.keywordId || ''}`, getters.apiHeader)
  await commit('updateScore', score)
}

const loadScoreAndReturn = async ({ getters }, data) => {
  const { data: score } = await axios.get(`${getters.apiUrl}/contentplan/${data.contentplanId}/article/score?articleId=${data.articleId || ''}&keywordId=${data.keywordId || ''}`, getters.apiHeader)
  return score
}

const runUpdateStatemachine = async ({ getters }, data) => {
  await axios.post(`${getters.apiUrl}/contentplan/${data.contentplanId}/update`, getters.apiHeader)
}

const startCrawl = async ({ getters }, data) => {
  await axios.post(`${getters.apiUrl}/contentplan/${data.contentplanId}/crawl`, data, getters.apiHeader)
}

const loadCrawl = async ({ getters, commit }, data) => {
  const { data: crawl } = await axios.get(`${getters.apiUrl}/contentplan/${data.contentplanId}/crawl`, getters.apiHeader)
  await commit('loadCrawl', crawl)
}

const sendSlackNotification = ({ getters }, data) => {
  axios.post(`${getters.apiUrl}/slack`, data, getters.apiHeader)
}

const postUser = async ({ getters }, data) => {
  const { data: userId } = await axios.post(`${getters.apiUrl}/user/${data.workspaceId}`, data, getters.apiHeader)
  return userId
}

const generateArticleOutline = async ({ getters }, data) => {
  const { data: outline } = await axios.post(`${getters.apiUrl}/contentplan/${data.contentplanId}/article/${data.articleId}/outline`, data, getters.apiHeader)
  return outline
}

export default {
  // Benchmarks
  getBenchmarks,
  // Internal links
  loadInternalLinksByArticle,
  startClusterer,
  getClustererStatus,
  clustererSendEmail,
  loadWorkspaces,
  loadDomains,
  updateWorkspace,
  loadContentplans,
  loadContentplan,
  updateContentplan,
  createContentplan,
  loadContentplanKeywords,
  loadPageKeywords,
  getKeyword,
  getMostPopularKeywords,
  getPage,
  getPageFromS3,
  runUpdateStatemachine,
  uploadKeywords,
  getRelatedKeywords,
  getRelatedKeywordsNlp,
  getRelatedBySerpOverlap,
  excludeKeywords,
  queueKeywords,
  queueAllKeywords,
  updateKeywords,
  updatePages,
  moveKeywords,
  startCrawl,
  loadCrawl,
  addTopic,
  updateTopics,
  loadTopics,
  addArticle,
  loadArticles,
  loadArticlesAdvanced,
  loadArticle,
  loadArticleKeywords,
  loadArticleRankings,
  loadArticleUrls,
  loadArticleExternalUrls,
  loadScoreAndCommit,
  loadScoreAndReturn,
  analyzeLandingPage,
  updateArticles,
  loadArticlesByArticle,
  loadTopicKeywords,
  getKeywordsByKeyword,
  processKeywords,
  getGSCDataAndReturn,
  getGSCDataByDate,
  getGSCDataByQuery,
  getGSCDataByPage,
  postHierarchicalClustering,
  loadPagesByContentplan,
  loadPagesByArticle,
  loadPageArticles,
  loadPagesByKeywords,
  recalculateAlerts,
  postGpt3,
  postCopilot,
  generateBrief,
  generateDraft,
  loadSections,
  updateSections,
  addSection,
  sendSlackNotification,
  postUser,
  generateArticleOutline
}
